import React, { Component } from 'react'
import RecordAPI from '@/API/record'
import { Table, Spin } from 'antd'
import styled from "styled-components"
import dayjs from 'dayjs'
import { withTranslation } from 'react-i18next';

const ExpandTable = styled(Table)`
  ul.ant-table-pagination{
    display:none;
  }
  .ant-table-thead{
    display:none;
  }
`;

const Center = styled.div`
  text-align:center;
`;


const Danger = styled.div`
  color:#f81d22;
`;

class RecordExpandTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      recordList:[]
    };
  }
  componentDidMount() {
    this.getData()
  }
  getData=()=>{
    let {imei,startTime,endTime}=this.props
    this.setState({loading:true})
    RecordAPI.getRecords({
      imei:imei,
      startTime:startTime?dayjs(startTime).format('YYYY-MM-DD'):null,
      endTime:endTime?dayjs(endTime).format('YYYY-MM-DD'):null
    }).then((res)=>{
      let recordList=res.data||[]
      recordList.length&&recordList.shift()
      this.setState({
        recordList:recordList,
        loading:false
      })
    })
  }
  render() {
    const {recordList,loading}=this.state
    const {t,imei,}=this.props
    const columns=[
      {
        title:t('IMEI'),
        key:'imei',
        width:150,
        align:'center',
        render:()=>(
          imei
        )
      },
      {
        title:t('Type'),
        dataIndex:'notifyType',
        key:'notifyType',
        width:150,
        align:'center'
      },
      {
        title:t('Date'),
        key:'time',
        width:180,
        align:'center',
        render:(text,record)=>{
          return dayjs(record.time).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title:t('Carrier Code'),
        dataIndex:'operator',
        key:'operator',
        width:180,
        align:'center'
      },
      {
        title:t('Operator'),
        dataIndex:'userName',
        key:'userName',
        width:250,
        align:'center'
      },
      {
        title:t('MarketingName'),
        dataIndex:'marketingName',
        key:'marketingName',
        width:250,
        align:'center'
      },
      {
        title:t('Notify By'),
        dataIndex:'notifyBy',
        key:'notifyBy',
        width:250,
        align:'center',
        render:(text,record)=>{
          return !record.notifyBy? 'API':'Manual'
        }
      },
      {
        title:t('Status'),
        key:'status',
        width:100,
        align:'center',
        render:(text,record)=>{
          return record.status===0?t('Successful'):<Danger>{t('Failed')}</Danger>
        }
      },
      {
        title:t('Operation'),
        width:100,
        align:'center',
        key:'action',
        render:(text,record)=>('')
      }
    ]
    return (
      <Spin spinning={loading}>
      {
        !loading?(recordList.length?<ExpandTable columns={columns} dataSource={recordList} rowKey="time" pagination={false}></ExpandTable>:<Center>{t('No data available.')}</Center>):<div></div>
      }
      </Spin>
    )
  }
}

export default withTranslation()(RecordExpandTable);